// GoBD.jsx
import React from 'react'
import { Helmet } from 'react-helmet-async'

function GoBD() {
  return (
    <>
      <Helmet>
        <title>GoBD | Payroll Expert</title>
        <meta name="description" content="GoBD-Konformität bei Payroll Expert: Wir setzen alle GoBD-Prinzipien für Ihre Lohnabrechnung um." />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-20 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
        <h1 className="text-4xl font-black text-gray-900 mb-12 text-center border-b-4 border-indigo-600 pb-8">
          GoBD-Einhaltung
        </h1>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-indigo-900 mb-6 flex items-center gap-3">
              <span className="w-2 h-8 bg-indigo-500 rounded-full"></span>
              GoBD-Prinzipien vollständig umgesetzt
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                'Vollständigkeit', 'Unveränderbarkeit', 'Sofortigkeit', 
                'Lesbarkeit', 'Unveränderliche Reihenfolge', 'Nachvollziehbarkeit'
              ].map((principle, idx) => (
                <div key={idx} className="p-6 bg-indigo-50 border border-indigo-200 rounded-xl text-center">
                  <div className="w-16 h-16 bg-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <span className="font-bold text-indigo-700">{idx + 1}</span>
                  </div>
                  <h4 className="font-bold text-lg mb-2">{principle}</h4>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-indigo-900 mb-6">Technische Umsetzung</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="p-8 bg-gray-50 rounded-2xl">
                <h4 className="font-bold text-xl mb-4">Datenintegrität</h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ Hash-Werte pro Dokument</li>
                  <li>✓ Versionskontrolle</li>
                  <li>✓ Audit-Trail (Änderungen protokolliert)</li>
                  <li>✓ Block-Chain-Prinzip</li>
                </ul>
              </div>
              <div className="p-8 bg-gray-50 rounded-2xl">
                <h4 className="font-bold text-xl mb-4">Zugriffssteuerung</h4>
                <ul className="space-y-2 text-sm">
                  <li>✓ Rollenbasierte Rechte</li>
                  <li>✓ 2FA für Mandantenportal</li>
                  <li>✓ Sitzungsprotokollierung</li>
                  <li>✓ EU-Server (Datenschutz)</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="pt-8 border-t border-gray-200">
            <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-8 text-center">
              <div className="w-20 h-20 bg-green-100 rounded-3xl flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-black text-green-700">✓</span>
              </div>
              <h3 className="text-2xl font-black text-green-900 mb-4">
                100% GoBD-konform
              </h3>
              <p className="text-lg text-green-800">
                Unsere Prozesse entsprechen vollständig den Grundsätzen zur ordnungsmäßigen 
                Führung und Aufbewahrung von Büchern, Aufzeichnungen und Unterlagen in 
                elektronischer Form sowie zum Datenzugriff (GoBD).
              </p>
            </div>
          </section>
        </div>
      </div>
      </div>
    </>
  )
}

export default GoBD
